import React from 'react';
import { Linkedin, Mail, Award, Briefcase, Sparkles } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import emmanuelImage from '../assets/emmanuel.jpg';

const skills = ['n8n Workflows', 'AI Integration', 'WhatsApp Automation', 'CRM Systems', 'API Development', 'Process Optimization'];

const Team: React.FC = () => {
    return (
        <section id="team" className="relative py-24 md:py-32 overflow-hidden">
            <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-brand-cyan/10 rounded-full blur-[130px] opacity-30 pointer-events-none" />

            <div className="container-x relative z-10">
                <Reveal className="max-w-4xl mx-auto">
                    <div className="grid lg:grid-cols-[320px_1fr] gap-10 items-center rounded-3xl card-surface p-8 md:p-12 shadow-lift">
                        {/* Profile image */}
                        <div className="flex flex-col items-center lg:items-start">
                            <div className="relative group">
                                <div className="absolute -inset-4 bg-gradient-to-br from-brand-cyan to-brand-blue rounded-3xl blur-2xl opacity-30 group-hover:opacity-50 transition-opacity pointer-events-none" />
                                <div className="relative rounded-2xl overflow-hidden border-2 border-brand-cyan/30 group-hover:border-brand-cyan/60 transition-all shadow-xl">
                                    <img
                                        src={emmanuelImage}
                                        alt="Emmanuel O. Ada, Lead Automation Engineer"
                                        className="w-full h-full object-cover"
                                        loading="lazy"
                                    />
                                </div>
                            </div>

                            <div className="flex gap-3 mt-6">
                                <a
                                    href="https://www.linkedin.com/in/emmanuel-ada/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-11 h-11 rounded-xl bg-white/[0.05] border border-white/[0.1] grid place-items-center text-text-muted hover:text-brand-cyan hover:border-brand-cyan/50 transition-all"
                                    aria-label="Emmanuel Ada on LinkedIn"
                                >
                                    <Linkedin className="w-5 h-5" />
                                </a>
                                <a
                                    href="mailto:info@automateit.ng"
                                    className="w-11 h-11 rounded-xl bg-white/[0.05] border border-white/[0.1] grid place-items-center text-text-muted hover:text-brand-cyan hover:border-brand-cyan/50 transition-all"
                                    aria-label="Email AutomateIT.ng"
                                >
                                    <Mail className="w-5 h-5" />
                                </a>
                            </div>
                        </div>

                        {/* Profile content */}
                        <div>
                            <span className="eyebrow mb-4">
                                <Sparkles className="w-4 h-4" /> Meet the founder
                            </span>
                            <h3 className="font-display text-3xl font-bold text-white">Emmanuel O. Ada</h3>
                            <p className="text-brand-cyan font-semibold mt-1">Lead Software & Automation Engineer</p>

                            <p className="mt-5 text-text-muted leading-relaxed">
                                A full-stack engineer specialising in frontend, backend, mobile, and AI. Emmanuel builds
                                intelligent automation systems that turn complex, manual operations into streamlined,
                                AI-powered workflows — helping businesses eliminate busywork and scale with confidence.
                            </p>

                            <div className="grid sm:grid-cols-2 gap-4 mt-7">
                                <div className="flex items-start gap-3">
                                    <div className="w-11 h-11 rounded-xl bg-brand-cyan/10 grid place-items-center shrink-0">
                                        <Award className="w-5 h-5 text-brand-cyan" />
                                    </div>
                                    <div>
                                        <div className="text-white font-semibold">50+ Projects</div>
                                        <div className="text-sm text-text-muted">Automation solutions delivered</div>
                                    </div>
                                </div>
                                <div className="flex items-start gap-3">
                                    <div className="w-11 h-11 rounded-xl bg-brand-blue/10 grid place-items-center shrink-0">
                                        <Briefcase className="w-5 h-5 text-brand-blue" />
                                    </div>
                                    <div>
                                        <div className="text-white font-semibold">5+ Years</div>
                                        <div className="text-sm text-text-muted">Building automation systems</div>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-7 pt-6 border-t border-white/[0.06]">
                                <div className="text-xs font-semibold text-text-faint uppercase tracking-wider mb-3">Core expertise</div>
                                <div className="flex flex-wrap gap-2">
                                    {skills.map((skill) => (
                                        <span key={skill} className="px-3 py-1.5 rounded-lg bg-white/[0.03] border border-white/[0.06] text-text-muted text-sm">
                                            {skill}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default Team;
